import { k2UserSchema } from '@k2/common/users-state/normalizer-schemas';
import { schema } from 'normalizr';

export const officeSchema = new schema.Entity('offices', {
  contact: k2UserSchema
});

export const officesListSchema = new schema.Array(officeSchema);
